// Shared constants for the Studio page and its sub-components.
export const TRACK_KINDS = [
  { v: "rhythm", l: "Rhythm", c: "#A8FF1F" },
  { v: "melody", l: "Melody", c: "#60A5FA" },
  { v: "vocal", l: "Vocal", c: "#FBBF24" },
  { v: "drums", l: "Drums", c: "#34D399" },
];

export const GRID_DIVISIONS = [
  { v: 4, l: "1/4" },
  { v: 8, l: "1/8" },
  { v: 16, l: "1/16" },
  { v: 32, l: "1/32" },
];

// Excludes "drums" because drums tracks are derived (Drumify), not recorded directly.
export const RECORDABLE_TRACK_KINDS = TRACK_KINDS.filter((k) => k.v !== "drums");

export function kindOf(kind) {
  return TRACK_KINDS.find((k) => k.v === kind) || TRACK_KINDS[0];
}
